import OfferResaleTableTr from "./offer-resale-table-tr";
export default OfferResaleTableTr;